import { Autocomplete, TextField, Chip } from '@mui/material';
import { useState } from 'react';

interface Props {
  options: any;
  form: any;
  setForm: (data: any) => void;
  value: any;
  label: string;
  placeholder?: string;
  helperText?: string;
}

const AutocompleteInputName: React.FC<Props> = (props) => {
  const [value, setValue] = useState<string | null>(null);

  return (
    <Autocomplete
      freeSolo // Allows custom input
      disableClearable
      options={props.options}
      value={props.value}
      // onChange={(event, newValue) => {
      //   setValue(newValue);
      // }}
      onChange={(_, value) =>
                  props.setForm((f:any) => 
                    ({ ...f, 
                      name: value || "" 
                    }))
                }
      onInputChange={(_, value) =>
                  props.setForm((f:any) => 
                    ({ ...f, 
                      name: value 
                    }))
                }
      renderInput={(params) => (
        <TextField
          autoFocus
          {...params}
          label={props.label}
          placeholder={props.placeholder || undefined}
          helperText={props.helperText}
        />
      )}
      renderOption={(props, option) => (
        <li {...props}>
          <Chip label={option} size="small" sx={{ mr: 1 }} />
          {option}
        </li>
      )}
    />
  );
}

export default AutocompleteInputName;